export const AppLogoLight = ({
  height = 80,
  width = 80,
}: {
  height: number;
  width: number;
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1191_10088)">
        <rect x="0.138428" width="36" height="36" fill="#1E293B" />
        <path
          d="M18.205 14.8299H17.4918C17.1946 13.1013 16.3032 11.8495 14.4906 11.8495C12.1728 11.8495 10.9248 14.1444 10.9248 17.9891C10.9248 21.5954 12.47 23.5923 15.3523 23.5923C16.5706 23.5923 17.8781 22.9068 18.413 22.1915L18.7695 22.4895C18.5021 23.0558 18.2941 23.6519 18.1158 24.248C17.2541 24.9036 15.9169 25.5295 14.1043 25.5295C8.30989 25.5295 6.37842 21.5954 6.37842 17.9593C6.37842 13.5782 9.46877 10.3295 14.2232 10.3295C16.4221 10.3295 17.9078 10.8958 19.3341 11.7303C18.8587 12.5052 18.413 13.7868 18.205 14.8299Z"
          fill="white"
        />
        <path
          d="M24.9627 10.7299L24.8736 14.3704L24.933 14.4301C25.9724 11.6848 27.4276 10.4315 29.4174 10.4315C29.5955 10.4315 29.744 10.4614 29.8925 10.4614C29.7737 11.0582 29.7143 11.6848 29.7143 12.6099C29.7143 13.2067 29.7143 13.893 29.744 14.5793L29.4768 14.818C29.0907 14.5793 28.5858 14.4003 27.9622 14.4003C26.1803 14.4003 25.0815 15.7729 25.0815 17.3544V18.548C25.0815 20.965 25.1409 23.0837 25.319 25.1725C24.8142 25.1128 24.0123 25.0233 23.0917 25.0233C22.1711 25.0233 21.3989 25.1128 20.8643 25.1725C21.0425 23.0837 21.1019 20.965 21.1019 18.548V17.3544C21.1019 14.9374 21.0425 12.8187 20.8643 10.7299C21.5474 10.7896 22.2304 10.8791 22.9135 10.8791C23.5966 10.8791 24.2796 10.7896 24.9627 10.7299Z"
          fill="white"
        />
        <path
          d="M21.0774 16.8562C21.1535 19.9014 18.4617 22.3086 17.206 23.1181C15.6459 24.236 17.7884 24.5141 18.0431 24.3131C22.0007 21.1907 21.0112 20.9594 22.6095 18.0683C22.0894 16.5649 21.0165 14.4199 21.0774 16.8562Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1191_10088">
          <rect x="0.138428" width="36" height="36" rx="8.61539" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
